module.exports = __webpack_public_path__ + "static/img/mb-03.d34ddca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x3/mb-03.jpg
// module id = 7P2g
// module chunks = 1